// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShopExpansion_wrapper__31Fg8","topList":"ShopExpansion_topList__1BW97","unorderedList":"ShopExpansion_unorderedList__AA0pZ"};